import { AcceptedFileTypes } from './types';

export const getFileExtensionMimeType = (mimeType: string) => {
    switch (mimeType) {
        case 'image/png':
            return AcceptedFileTypes.PNG;
        case 'image/jpeg':
            return AcceptedFileTypes.JPG;
        case 'application/pdf':
            return AcceptedFileTypes.PDF;
        default:
            return '';
    }
};
